export default "__VITE_ASSET__6aa9cab6__"